import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Search } from "lucide-react";
import Layout from "@/components/Layout";
import SectionHeader from "@/components/SectionHeader";
import { useI18n } from "@/i18n";
import { vehicles } from "@/data/vehicles";

export default function Vehicles() {
  const { t, lang } = useI18n();
  const [q, setQ] = useState("");

  const filtered = useMemo(() => {
    if (!q) return vehicles;
    return vehicles.filter((v) => v.name.toLowerCase().includes(q.toLowerCase()));
  }, [q]);

  return (
    <Layout seoTitle={t("vehicles.title")} seoDescription={t("vehicles.subtitle")}>
      <section className="section-y">
        <div className="container-mt">
          <SectionHeader as="h1" num="01" kicker={t("labels.vehicleDatabase")} title={t("vehicles.title")} subtitle={t("vehicles.subtitle")} />

          <div className="relative mb-10 max-w-md">
            <Search size={15} className="absolute left-4 top-1/2 -translate-y-1/2 text-zinc-500" />
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder={t("vehicles.searchPlaceholder")}
              aria-label={t("vehicles.searchPlaceholder")}
              className="input-mt pl-11"
              data-testid="vehicles-search"
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
            {filtered.map((v, i) => (
              <Link
                key={v.slug}
                to={`/vehicles/${v.slug}`}
                data-testid={`vehicle-card-${v.slug}`}
                className="card-mt card-mt-pad card-interactive group flex flex-col justify-between min-h-[190px]"
              >
                <div className="flex items-start justify-between mb-8">
                  <span className="num-chip">{String(i + 1).padStart(2, "0")}</span>
                  <span className="eyebrow text-[10px]">{v.engines.length} {lang === "lt" ? "varikliai" : "engines"}</span>
                </div>
                <div>
                  <h2 className="h-display text-3xl md:text-4xl text-white group-hover:text-brand-lime transition-colors duration-300 mb-4 leading-none">
                    {v.name}
                  </h2>
                  <div className="flex items-center justify-between">
                    <div className="flex flex-wrap gap-1.5">
                      {v.engines.slice(0, 3).map((e) => (
                        <span key={e} className="text-[10px] font-mono uppercase tracking-widest text-zinc-500">{e}</span>
                      ))}
                      {v.engines.length > 3 && (
                        <span className="text-[10px] font-mono text-zinc-600">+{v.engines.length - 3}</span>
                      )}
                    </div>
                    <ArrowRight size={14} className="text-brand-lime transition-transform duration-300 group-hover:translate-x-1" />
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {filtered.length === 0 && (
            <div className="text-center py-24">
              <p className="text-zinc-500 font-mono uppercase tracking-widest text-xs">— No matches —</p>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
}
